module.exports = __webpack_public_path__ + "static/img/cb6e1df6507e3fd2ee2e2c80eea8b9a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/six_icon1.png
// module id = mdIL
// module chunks = 1